import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import Reveal from "./Reveal";

const CHAPTERS = [
  {
    n: "01",
    title: "Precisão",
    text: "Cada declaração, cada NCM e cada documento é conferido com rigor técnico. No despacho aduaneiro, o detalhe é o que separa uma carga liberada de uma carga retida.",
  },
  {
    n: "02",
    title: "Agilidade",
    text: "Carga parada é custo. Trabalhamos com processos enxutos e acompanhamento próximo para reduzir prazos e destravar a sua operação.",
  },
  {
    n: "03",
    title: "Confiança",
    text: "Relacionamento direto, sem intermediários. Você fala com quem executa — por telefone, WhatsApp ou e-mail — e acompanha cada etapa do processo.",
  },
];

const About = () => {
  const imgRef = useRef(null);
  const { scrollYProgress } = useScroll({ target: imgRef, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-12%", "12%"]);

  return (
    <section id="sobre" className="border-t border-ink/15" data-testid="about-section">
      <div className="px-6 py-24 lg:px-12 lg:py-36">
        <Reveal>
          <div className="mb-16 flex flex-col gap-4 lg:mb-24">
            <span className="font-mono text-xs uppercase tracking-[0.35em] text-ink/50">
              03 / Sobre
            </span>
            <h2 className="max-w-4xl font-oswald text-4xl font-bold uppercase leading-none tracking-tight sm:text-5xl lg:text-7xl">
              Quem move a sua carga
            </h2>
            <p className="max-w-2xl text-base font-light leading-relaxed text-ink/60 lg:text-lg">
              A JVF Assessoria e Despachos Aduaneiros LTDA é uma empresa gaúcha,
              fundada em 2021 e especializada em comércio exterior, com profissionais
              qualificados e mais de 20 anos de experiência. Cuidamos de todo o
              processo aduaneiro da sua operação — desde a habilitação no Siscomex
              até a liberação da carga e a entrega no local desejado — para que sua
              mercadoria atravesse fronteiras com segurança, agilidade e menos
              burocracia.
            </p>
          </div>
        </Reveal>

        <div className="flex flex-col">
          {CHAPTERS.map((c, i) => (
            <Reveal key={c.n} delay={i * 0.08}>
              <div
                className={`grid grid-cols-12 gap-6 border-t border-ink/15 py-14 lg:py-20 ${
                  i === CHAPTERS.length - 1 ? "border-b" : ""
                }`}
                data-testid={`manifesto-chapter-${c.n}`}
              >
                <span className="col-span-12 font-oswald text-6xl font-bold leading-none text-ink/10 md:col-span-3 lg:text-8xl">
                  {c.n}
                </span>
                <div className="col-span-12 flex flex-col gap-5 md:col-span-8 md:col-start-5">
                  <h3 className="font-oswald text-3xl font-semibold uppercase tracking-tight lg:text-4xl">
                    {c.title}
                  </h3>
                  <p className="max-w-xl text-base font-light leading-relaxed text-ink/60 lg:text-lg">
                    {c.text}
                  </p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>

      <div ref={imgRef} className="relative h-[45vh] overflow-hidden lg:h-[60vh]" data-testid="about-image-frame">
        <motion.img
          style={{ y }}
          src="https://images.unsplash.com/photo-1715499337934-54e92d1ca320?auto=format&fit=crop&w=1800&q=80"
          alt="Terminal de contêineres à noite"
          className="absolute inset-0 h-[124%] w-full object-cover brightness-[0.45] contrast-125 grayscale"
          data-testid="about-image"
        />
        <div className="absolute inset-0 flex items-end px-6 pb-8 lg:px-12">
          <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-white/80">
            Comércio exterior — sem fronteiras para a sua operação
          </p>
        </div>
      </div>
    </section>
  );
};

export default About;
